export default __webpack_public_path__ + "static/media/schedule-close.9d7bfba1.svg";